// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import {
    api,
    IApiResponse,
    IPaginateApiResponse,
} from 'common/api/resources/Response';
import {
    IAccessTokenResponse,
    IApiTokenListRequest,
    IApiTokenCreateRequest,
    IApiTokenResponse,
    IApiTokenPatchRequest,
} from 'common/api/resources/ApiToken/model';
import { QueryBuilder } from 'common/api/resources/Request/QueryBuilder';

export const apiTokens = {
    list: (params?: IApiTokenListRequest) => api.get<IPaginateApiResponse<IApiTokenResponse[]>>('api_tokens', {
        params: new QueryBuilder(params).build(),
    }),
    item: (id: string) => api.get<IApiResponse<IApiTokenResponse>>(`api_tokens/${id}`),
    create: (data: IApiTokenCreateRequest) => api.post<IAccessTokenResponse>('api_tokens', data),
    patch: (id: string, data: IApiTokenPatchRequest) => api.patch<IApiResponse<IApiTokenResponse>>(`api_tokens/${id}`, data),
    remove: (id: string) => api.delete(`api_tokens/${id}`),
};
